import { helper } from '@ember/component/helper';

import { qpDateRangeIsOutsideRange } from 'rise-ui/utils/qp-date.js';

export default helper(function dateUnboundHelper([ start, end, dates ], options) {
  return qpDateRangeIsOutsideRange({ from: start, to: end }, dates, options);
});
